import Vue from 'vue'
import clone from 'clone'
import { QUOTE_MOTOR_PARAM, QUOTE_MOTOR_PARAM_GENERAL, QUOTE_MOTOR_GENERAL, QUOTE_MOTOR_PARAM_PERMSTATS, QUOTE_MOTOR_DRIVER, QUOTE_MOTOR_PARAM_VEHICLE, QUOTE_MOTOR_PARAM_MAKE, QUOTE_MOTOR_VEHICLE, QUOTE_MOTOR_PARAM_STATS, QUOTE_MOTOR_PARAM_STATS_FAIL, QUOTE_MOTOR_PARAM_STATS_LOADING, QUOTE_MOTOR_STATISTICS, QUOTE_MOTOR_PARAM_EXCESS, QUOTE_MOTOR_PARAM_EXCESS_FAIL, QUOTE_MOTOR_PARAM_EXCESS_LOADING, QUOTE_MOTOR_EXCESS, QUOTE_MOTOR_PARAM_ADDBEN, QUOTE_MOTOR_PARAM_ADDBEN_LOADING, QUOTE_MOTOR_PARAM_ADDBEN_FAIL, QUOTE_MOTOR_ADDBENS, QUOTE_MOTOR_ADDBEN, QUOTE_MOTOR_REMOVEBEN, PROPOSAL_MOTOR_GENERAL, PROPOSAL_MOTOR_PAYMENT, QUOTE_MOTOR_PARAM_PLAN_LOADING, QUOTE_MOTOR_PARAM_PLAN_SUCCESS, QUOTE_MOTOR_PARAM_PLAN_FAIL, QUOTE_MOTOR_PLAN, AGENCY_QUOTATION_RESET_BENEFIT } from '@/store/types'
import { removeFormatNumber } from '@/utils/number'
import { formatServerTimeFormat } from '@/utils/date'

export const motor = {
  [QUOTE_MOTOR_PARAM](state, data) {
    // Note: Key - ignoreValue is reserved
    if (data) {
      const formatData = data
      let ignoreValue = data.ignoreValue
      if (ignoreValue === undefined) {
        ignoreValue = false
      }
      Object.keys(formatData).forEach(function (key) {
        if (key !== 'ignoreValue') {
          const arr = formatData[key]
          if (arr) {
            if (Array.isArray(arr)) {
              // Make it so that its value - label (easier to search)
              arr.map(obj => {
                if (!ignoreValue) {
                  obj.label = obj.value + ' - ' + obj.label
                }
              })
            }
            // Initially was using the Object.assign below
            // But due to vue js reactive caveats, we will use Vue.set instead
            Vue.set(state.quotation.motorParam, key, arr)
          }
        }
      })
      // Object.assign(state.quotation.motorParam, formatData)
    }
  },
  [QUOTE_MOTOR_PARAM_PERMSTATS](state, data) {
    state.quotation.motorParam.permStatuses = data
  },
  [QUOTE_MOTOR_PARAM_MAKE](state, data) {
    if (data.data && data.data.length > 0) {
      // Make it so that its value - label (easier to search)
      data.data.map(obj => {
        obj.label = obj.value + ' - ' + obj.label
      })
    }
    state.quotation.motorParam.vehMake.data = data.data
    state.quotation.motorParam.vehMake.menu = data.menu
  },
  [QUOTE_MOTOR_PARAM_GENERAL](state) {
    state.quotation.motorParam.generalLoaded = true
  },
  [QUOTE_MOTOR_PARAM_VEHICLE](state, data) {
    // Pass data in instead of defaulting is because we might need a param reload (changing of buscls - vehgrp)
    state.quotation.motorParam.vehicleLoaded = data
  },
  [QUOTE_MOTOR_GENERAL](state, data) {
    if (data) {
      state.quotation.commonForm.product = data.product
      state.quotation.motorForm.busCls = data.busCls
      state.quotation.motorForm.tariff = data.tariff
      state.quotation.motorForm.cover = data.cover
      state.quotation.commonForm.startDate = data.startDate
      state.quotation.commonForm.endDate = data.endDate
      state.quotation.commonForm.acceptDate = data.acceptDate
      state.quotation.commonForm.campaign = data.campaign
      state.quotation.commonForm.promotion = data.promotion
      state.quotation.motorForm.exClm = data.exClm
      state.quotation.motorForm.noClm = data.noClm
      if (data.clmAmt) {
        state.quotation.motorForm.clmAmt = removeFormatNumber(data.clmAmt)
      }
      state.quotation.motorForm.ncdRate = data.ncdRate
      state.quotation.motorForm.ncdPct = data.ncdPct
    }
  },
  [QUOTE_MOTOR_DRIVER](state, data) {
    if (data) {
      // Applicant Information
      const { applicant } = state.quotation.commonForm

      applicant.appIntStat = data.applicant.appIntStat
      applicant.appSalutation = data.applicant.appSalutation
      applicant.appOccupation = data.applicant.appOccupation
      applicant.appName = data.applicant.appName
      applicant.appNricPassport = data.applicant.appNricPassport
      if (data.applicant.appDob) {
        applicant.appDob = formatServerTimeFormat(data.applicant.appDob)
      }
      applicant.appGender = data.applicant.appGender
      applicant.appEmail = data.applicant.appEmail
      applicant.appMobileNo = data.applicant.appMobileNo
      applicant.appTelNo1 = data.applicant.appTelNo1
      applicant.appTelNo2 = data.applicant.appTelNo2
      applicant.appPostalCode = data.applicant.appPostalCode
      applicant.appAdd1 = data.applicant.appAdd1
      applicant.appAdd2 = data.applicant.appAdd2
      applicant.appAdd3 = data.applicant.appAdd3
      applicant.appAdd4 = data.applicant.appAdd4
      applicant.mailAdd = data.applicant.mailAdd
      applicant.mailPostalCode = data.applicant.mailPostalCode
      applicant.mailAdd1 = data.applicant.mailAdd1
      applicant.mailAdd2 = data.applicant.mailAdd2
      applicant.mailAdd3 = data.applicant.mailAdd3
      applicant.mailAdd4 = data.applicant.mailAdd4
      applicant.coyName = data.applicant.coyName
      applicant.coyRocUen = data.applicant.coyRocUen
      applicant.coyNature = data.applicant.coyNature
      applicant.appIsDrv = data.applicant.appIsDrv

      // Drivers Information
      state.quotation.motorForm.drivers = clone(data.drivers)
      if (state.quotation.motorForm.drivers && state.quotation.motorForm.drivers.length > 0) {
        for (const driver of state.quotation.motorForm.drivers) {
          if (driver && driver.drvDob) {
            driver.drvDob = formatServerTimeFormat(driver.drvDob)
          }
        }
      }
    }
  },
  [QUOTE_MOTOR_VEHICLE](state, data) {
    if (data) {
      state.quotation.motorForm.vehRegNo = data.vehRegNo
      state.quotation.motorForm.vehUsg = data.vehUsg
      state.quotation.motorForm.vehMake = data.vehMake
      state.quotation.motorForm.vehModel = data.vehModel
      state.quotation.motorForm.vehManuYr = data.vehManuYr
      if (data.vehValue) {
        state.quotation.motorForm.vehValue = removeFormatNumber(data.vehValue)
      }
      state.quotation.motorForm.vehRegMth = data.vehRegMth
      state.quotation.motorForm.vehRegYr = data.vehRegYr
      state.quotation.motorForm.engineNo = data.engineNo
      state.quotation.motorForm.chassisNo = data.chassisNo
      state.quotation.commonForm.finInst = data.finInst
      state.quotation.motorForm.maxLaden = removeFormatNumber(data.maxLaden)
      state.quotation.motorForm.unLaden = removeFormatNumber(data.unLaden)
      state.quotation.motorForm.calcTonnage = removeFormatNumber(data.calcTonnage)
    }
  },
  [QUOTE_MOTOR_PARAM_STATS_LOADING](state) {
    state.quotation.motorParam.statisticsInit = 0
  },
  [QUOTE_MOTOR_PARAM_STATS](state, data) {
    state.quotation.motorParam.statistics = clone(data)

    state.quotation.motorParam.statisticsInit = 1
  },
  [QUOTE_MOTOR_PARAM_STATS_FAIL](state) {
    state.quotation.motorParam.statisticsInit = 2
  },
  [QUOTE_MOTOR_STATISTICS](state, data) {
    state.quotation.motorForm.statistics = clone(data)
  },
  [QUOTE_MOTOR_PARAM_EXCESS_LOADING](state) {
    state.quotation.motorParam.excessInit = 0
  },
  [QUOTE_MOTOR_PARAM_EXCESS](state, data) {
    state.quotation.motorParam.excess = clone(data)

    state.quotation.motorParam.excessInit = 1
  },
  [QUOTE_MOTOR_PARAM_EXCESS_FAIL](state) {
    state.quotation.motorParam.excessInit = 2
  },
  [QUOTE_MOTOR_EXCESS](state, data) {
    const excessData = clone(data)
    if (excessData && excessData.length > 0) {
      for (let excess of excessData) {
        excess.value = removeFormatNumber(excess.value)
      }
    }
    state.quotation.motorForm.excess = clone(excessData)
  },
  [QUOTE_MOTOR_PLAN](state, data) {
    if (data) {
      state.quotation.motorForm.mtrPlan = data
      // If there is plan selected, we will clear off addBenefits (So the premium screen value will be consistent with plan value)
      state.quotation.motorForm.addBenefits = null
    } else {
      state.quotation.motorForm.mtrPlan = null
    }
  },
  [QUOTE_MOTOR_PARAM_ADDBEN](state, data) {
    state.quotation.motorParam.addBenefits = clone(data)

    state.quotation.motorParam.addBenefitsInit = 1
  },
  [QUOTE_MOTOR_PARAM_ADDBEN_LOADING](state, data) {
    state.quotation.motorParam.addBenefitsInit = 0
  },
  [QUOTE_MOTOR_PARAM_ADDBEN_FAIL](state, data) {
    state.quotation.motorParam.addBenefitsInit = 2
  },
  [QUOTE_MOTOR_ADDBENS](state, data) {
    if (data) {
      state.quotation.motorForm.addBenefits = clone(data)
    } else {
      state.quotation.motorForm.addBenefits = null
    }
  },
  [QUOTE_MOTOR_ADDBEN](state, data) {
    // This method is use to append to existing data
    if (!state.quotation.motorForm.addBenefits || state.quotation.motorForm.addBenefits === null) {
      state.quotation.motorForm.addBenefits = []
    }
    // If not exist, add in
    if (!state.quotation.motorForm.addBenefits.find(a => a === data)) {
      state.quotation.motorForm.addBenefits.push(data)
    }
  },
  [QUOTE_MOTOR_REMOVEBEN](state, data) {
    if (state.quotation.motorForm.addBenefits && state.quotation.motorForm.addBenefits !== null) {
      if (state.quotation.motorForm.addBenefits.find(a => a === data)) {
        state.quotation.motorForm.addBenefits.splice(state.quotation.motorForm.addBenefits.indexOf(state.quotation.motorForm.addBenefits.find(x => x === data)), 1)
      }
    }
  },
  [PROPOSAL_MOTOR_GENERAL](state, data) {
    if (data) {
      state.quotation.motorForm.exInsurer = data.exInsurer
      state.quotation.motorForm.exPolNo = data.exPolNo
      state.quotation.motorForm.exPolNoExp = data.exPolNoExp
    }
  },
  [PROPOSAL_MOTOR_PAYMENT](state, data) {
    state.quotation.commonForm.paytMode = data.paytMode
    state.quotation.commonForm.paytCCNo = data.paytCCNo
    state.quotation.commonForm.paytCCName = data.paytCCName
    state.quotation.commonForm.paytCCType = data.paytCCType
    state.quotation.commonForm.paytCCExpMth = data.paytCCExpMth
    state.quotation.commonForm.paytCCExpYr = data.paytCCExpYr
    state.quotation.commonForm.paytCCCvv = data.paytCCCvv
    state.quotation.commonForm.paytInstalmentPlan = data.paytInstalmentPlan
  },
  [QUOTE_MOTOR_PARAM_PLAN_LOADING](state) {
    state.quotation.motorParam.plans.init = 0
    state.quotation.motorParam.plans.statistics = []
    state.quotation.motorParam.plans.excess = []
    state.quotation.motorParam.plans.plans = []
  },
  [QUOTE_MOTOR_PARAM_PLAN_SUCCESS](state, data) {
    state.quotation.motorParam.plans.statistics = data.statistics
    state.quotation.motorParam.plans.excess = data.excess
    state.quotation.motorParam.plans.plans = data.plans
    state.quotation.motorParam.plans.init = 1
  },
  [QUOTE_MOTOR_PARAM_PLAN_FAIL](state) {
    state.quotation.motorParam.plans.init = 2
    state.quotation.motorParam.plans.statistics = []
    state.quotation.motorParam.plans.excess = []
    state.quotation.motorParam.plans.plans = []
  },
  [AGENCY_QUOTATION_RESET_BENEFIT](state) {
    state.quotation.motorForm.addBenefits = null
  }
}
